import React, { useEffect, useState } from 'react'
import { useSearchParams, Link } from 'react-router-dom'
import {
  Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TableHeader, 
  TableRow,
} from '@/components/ui/table'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import api from '@/lib/axiosInstance'
import { Edit, Search, Send, Trash } from 'lucide-react'
import { Spinner } from '@/components/ui/shadcn-io/spinner'
// import Alert from '@/components/Alert'
import { toast } from 'sonner'
import Pagination from '@/components/Pagination'

const toInt = (value: string | null, fallback: number) => {
    const parsed = parseInt(value ?? '', 10)
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback
}

const Consumers = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const [length] = useState<number>(() => toInt(searchParams.get('length'), 10))
    const [page, setPage] = useState<number>(() => toInt(searchParams.get('page'), 1))
    const [search, setSearch] = useState<string>(() => searchParams.get('search') || '')
    const [searchTerm, setSearchTerm] = useState<string>(() => searchParams.get('search') || '')
    const [consumers, setConsumers] = useState<any[]>([])
    const [totalPage, setTotalPages] = useState<number>(0)

    const getConsumers = async () => {
        try {
            const response = await api.get(
                `/consumers?page=${page}&length=${length}${searchTerm ? `&search=${encodeURIComponent(searchTerm)}` : ''}`
            );
            if (!response.data.status) throw new Error(response.data.error);
    
            setConsumers(response.data.consumers);
            setTotalPages(response.data.totalPages);
        } catch (err: any) {
            const errorMsg = err.response ? err.response.data.error : err.message;
            toast.error(errorMsg);
        }
    };

    // const deleteConsumer = async (consumerId: number) => {
    //     try {
    //         const response = await api.delete(`/Consumers/${consumerId}`)
    //         if (!response.data.status) throw new Error(response.data.error)
    //         toast.success('Successfully deleted!')
    //         getConsumers() 
    //     } catch (err: any) {
    //         const errorMsg = err.response ? err.response.data.error : err.message
    //         toast.error(errorMsg)
    //     }
    // }

    const syncParams = (nextPage: number, nextSearch: string) => {
        const params: Record<string, string> = {
            page: `${nextPage}`,
            length: `${length}`,
        }
        if (nextSearch.trim() !== '') params.search = nextSearch
        setSearchParams(params)
    }

    const handlePageClick = (pageNum: number) => {
        if (pageNum < 1 || pageNum > totalPage || pageNum === page) return
        setPage(pageNum)
        syncParams(pageNum, searchTerm)
    }

    const handleSearch = () => {
        const term = search.trim()
        setSearchTerm(term)
        setPage(1)
        syncParams(1, term)
    }

    useEffect(() => {
        getConsumers()
    }, [page, length, searchTerm])

    return (
        <div>
            <div className='flex justify-between my-5'>
                <div className='flex'>
                    <Input
                    placeholder='Search here...'
                    value={search}
                    onChange={e => setSearch(e.target.value)}/>
                    <Button variant={'outline'} className='ml-1' onClick={handleSearch}>
                        <Search color='grey'/>
                    </Button>
                </div>
                <Button asChild variant='default' size='sm'>
                    <Link to='/Consumers/add' className='!text-white'>NEW</Link>
                </Button>
            </div>

            <div className='overflow-x-auto w-full'>
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead className='w-[100px]'>No</TableHead>
                            <TableHead>Name</TableHead>
                            <TableHead>Email</TableHead>
                            <TableHead>Last active</TableHead>
                            <TableHead>Action</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {
                            consumers ? 
                            (
                                consumers.length > 0 ? (
                                    consumers.map((consumer, i) => (
                                        <TableRow key={consumer.id}>
                                            <TableCell>{(i + 1) + (page * length - length)}</TableCell>
                                            <TableCell>{consumer.firstName} {consumer.lastName}</TableCell>
                                            <TableCell>{consumer.email}</TableCell>
                                            <TableCell>{consumer.lastLogin || '-'}</TableCell>
                                            <TableCell>
                                                {!consumer.invitedAt && (
                                                    <Button asChild variant='outline' size='sm' className='mx-1'>
                                                        <Link to={`/Consumers/edit/${consumer.id}`} className='!text-black'>
                                                            <Send />
                                                        </Link>
                                                    </Button>
                                                )}
                                                <Button asChild variant='outline' size='sm' className='mx-1'>
                                                    <Link to={`/Consumers/edit/${consumer.id}`} className='!text-black'>
                                                        <Edit />
                                                    </Link>
                                                </Button>
                                                {/* <Alert
                                                    trigger={<Button variant='outline' size='sm' className='mx-1'><Trash /></Button>}
                                                    title='Delete consumer'
                                                    description={`Are you sure you want to delete ${consumer.firstName} ${consumer.lastName}?`}
                                                    confirmLabel='Delete'
                                                    cancelLabel='Cancel'
                                                    onConfirm={() => deleteconsumer(consumer.id)}
                                                /> */}
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : 
                                <TableRow className='text-center'>
                                    <TableCell colSpan={5} className='text-center'>
                                        No consumers.
                                    </TableCell>
                                </TableRow>
                            ) : (
                            <TableRow className='text-center'>
                                <TableCell colSpan={5} className='text-center'>
                                    <div className='flex justify-center items-center py-4'>
                                        <Spinner variant='circle' />
                                    </div>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </div>
            <Pagination
            totalPage={totalPage}
            currentPage={page}
            onPageChange={(newPage) => handlePageClick(newPage)} />
        </div>
    )
}

export default Consumers
